import React from 'react'

const Blog = () => {
  return (
    <div style={{marginTop:"80px"}}>Blog</div>
  )
}

export default Blog